<template>
  <div class="channel-cards">
    <div class="cards-container" v-if="items.length">
      <div class="card" :class="{selected: item.selected}" v-for="(item, index) of items" @click="toggleSelected(index)">
        <span class="mark"></span>
        <div class="img">
          <img :src="item.picture" alt="">
        </div>
        <div class="text">
          {{item.name}}
        </div>
      </div>
    </div>
    <div class="displayfield" v-if="!items.length">Nincs kiválasztható oldal</div>
  </div>
</template>

<script>
/* global */
import { mapState } from 'vuex'
// import $ from 'jquery'
import merge from 'merge'
import _ from 'lodash'

export default {
  name: 'channel-cards',
  props: ['name', 'value', 'service', 'channels'],
  data () {
    return {
      items: [],
      preSelection: null,
      loaded: false
    }
  },
  computed: {
    ...mapState(['user'])
  },
  mounted () {
    if (this.service) {
      this.service().then((res) => {
        if (res.success) {
          this.items = res[res.key].map((item) => merge(true, item, {selected: false}))
          this.loaded = true
          if (this.preSelection) {
            this.selectItems(this.preSelection)
          }
        }
      })
    } else if (this.channels) {
      this.items = this.channels.map((item) => merge(true, item, {selected: false}))
      this.loaded = true
      if (this.preSelection) {
        this.selectItems(this.preSelection)
      }
    }
  },
  watch: {
    value (items) {
      if (this.loaded) {
        this.selectItems(items)
      } else {
        this.preSelection = items
      }
    },
    channels (channels) {
      this.items = this.channels.map((item) => merge(true, item, {selected: false}))
    }
  },
  methods: {
    updateValue () {
      this.$emit('input', this.getSelectedItems())
    },
    toggleSelected (index) {
      var item = this.items[index]
      item.selected = !item.selected
      this.$set(this.items, index, item)
      this.updateValue()
    },
    getSelectedItems () {
      return this.items.filter((item) => item.selected)
    },
    findIndexById (id) {
      return _.findIndex(this.items, ['id', id])
    },
    selectItems (selection) {
      this.items.forEach((item, index) => {
        item = this.items[index]
        item.selected = false
        this.$set(this.items, index, item)
      })

      if (_.isArray(selection)) {
        selection.forEach((item) => {
          var index = this.findIndexById(item.id)
          if (index > -1) {
            item = this.items[index]
            item.selected = true
            this.$set(this.items, index, item)
          }
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import '../../sass/foundation-import';
  // @import '../../sass/inputs/channelcards';
  $card-width: rem-calc(90);
  $card-img-width: rem-calc(80);
  $card-img-height: rem-calc(80);

  .channel-cards {
    .cards-container {
      float: left;
      margin-bottom: $global-margin !important;
    }
    .card {
      background: #fff;
      padding: $global-margin / 4;
      margin: $global-margin / 4;
      width: $card-width;
      float: left;
      position: relative;
      .mark {
        background: #ededed;
        border: 2px solid #fff;
        width: 16px;
        height: 16px;
        display: block;
        position: absolute;
        top: -4px;
        right: -4px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        border-radius: 8px;
      }
      .img {
        width: $card-img-width;
        height: $card-img-height;
        background: #f0f0f0;
        text-align: center;
        opacity: 0.50;
        &:before {    /* create a full-height inline block pseudo=element */
          content: ' ';
          display: inline-block;
          vertical-align: middle;  /* vertical alignment of the inline element */
          height: 100%;
        }
        img {
          max-width: 100%;
          max-height: 100%;
          display: inline-block;
          vertical-align: middle;  /* vertical alignment of the inline element */
          font: 16px/1 Arial sans-serif;
        }
      }
      .text {
        padding-top: $global-margin / 2;
        padding-bottom: $global-margin / 4;
        text-transform: uppercase;
        font-size: 70%;
        line-height: 140%;
        text-overflow: ellipsis;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        opacity: 0.50;
      }
      &.selected {
        .mark {
          background: #5486fe;
        }
        .img {
          opacity: 1;
        }
        .text {
          opacity: 1;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// channel-cards.vue?489d8087